import script from "./ImageSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageSlider.vue?vue&type=script&setup=true&lang=js"

import "./ImageSlider.vue?vue&type=style&index=0&id=5b8f33e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8f33e0"]])

export default __exports__